// extracted by mini-css-extract-plugin
export default {"hotkey":"ActionButton_hotkey__D2vcc","content":"ActionButton_content__yA2FZ","root":"ActionButton_root__snasL","selected":"ActionButton_selected__Sshnm"};